import React from 'react';
import PropTypes from 'prop-types';
import Row from './row';

import './styles/metadata_conversions_table.scss';

const Table = ({
  items,
  refreshData,
  setEditableKey,
  setShowForm,
}) => {
  const listItems = items.map(({
    id,
    metadata_term,
    key_term,
    convert_to_tags,
    created_at
  }) => (
    <Row
      id={id}
      metaTerm={metadata_term}
      keyTerm={key_term}
      createdAt={created_at}
      convertToTags={convert_to_tags}
      key={id}
      setEditableKey={setEditableKey}
      setShowForm={setShowForm}
      onRemove={refreshData}
    />
  ));

  return (
    <ul className="metadata_conversions--table">
      <li className="headers">
        <h3>{t('Embedded Metadata Field')}</h3>
        <h3>{t('Converted to')}</h3>
        <span />
        <span>
          <span className="button-header" />
          <span className="button-header" />
        </span>
      </li>
      {listItems}
    </ul>
  );
};

Table.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    metadata_term: PropTypes.string,
    key_term: PropTypes.string,
    convert_to_tags: PropTypes.bool,
    created_at: PropTypes.string,
  })),
  refreshData: PropTypes.func,
  setEditableKey: PropTypes.func.isRequired,
  setShowForm: PropTypes.func.isRequired,
};

Table.defaultProps = {
  items: [],
  refreshData: () => {},
};

export default Table;
